import { render, staticRenderFns } from "./NavCart.vue?vue&type=template&id=37740e70&scoped=true&"
import script from "./NavCart.vue?vue&type=script&lang=js&"
export * from "./NavCart.vue?vue&type=script&lang=js&"
import style0 from "./NavCart.vue?vue&type=style&index=0&id=37740e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37740e70",
  null
  
)

export default component.exports